import axios from '@_system/axios/axios.js'
export default {
	path: '/supplier',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	pull(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/pull', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	synchronous(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/synchronous', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	import(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			})
		})
	},
	goodsimport(id, data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/goodsimport/' + id, data, (res) => {
				resolve(res.data)
			})
		})
	},
	listSettlementTask(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/listSettlementTask', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getParcel(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/getParcel', data, (res) => {
				resolve(res.data)
			})
		})
	},
	// listCurrentSettlementDate(data = {}) {
	// 	return new Promise((resolve,reject) => {
	// 		axios.get(this.path + '/listCurrentSettlementDate', data, (res) => {
	// 			resolve(res.data)
	// 		},reject)
	// 	})
	// },	
	
	
	
	getSettlementTask(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getSettlementTask/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deleteSettlementTask(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/deleteSettlementTask/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	updateSettlementTaststatus(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updateSettlementTaststatus', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	addSettlementTast(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/addSettlementTast', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updateSettlementTast(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updateSettlementTast', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getSupplierParcelByWarehouse(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getSupplierParcelByWarehouse', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updategoodsprice(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updategoodsprice', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	
	getAccountByWlnid(id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getAccountByWlnid/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	
	statisticsdata(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/statisticsdata', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	getgoodsinfoByBillCode(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getgoodsinfoByBillCode', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updateboxgauge(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updateboxgauge', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listboxgauge(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/listboxgauge', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	synchronousjindie(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/synchronousjindie', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	log(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/log', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	enable(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/enable', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/supplier.supplier', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	export (data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	goodsexport(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/goodsexport', data, (res) => {
				resolve(res.data)
			})
		})
	}
}
